import { apiRequest } from "../util/apiUtils";

export const creatChatList = async (params) => {
  try {
    const res = await apiRequest("post", `/communication/chat-create`, {
      body: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const ChatList = async (params) => {
  try {
    const res = await apiRequest("get", `/communication/chat-list`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const ChatInfo = async (params) => {
  try {
    const res = await apiRequest("get", `/communication/get-message-details`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const ChatMessages = async (params) => {
  try {
    const res = await apiRequest("get", `/communication/get-message`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const sendMessage = async (params, uploadProgress = () => {}) => {
  try {
    const res = await apiRequest(
      "post",
      `/communication/send-message`,
      {
        body: params,
      },
      "multipart/form-data",
      uploadProgress
    );
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const messageList = async (params) => {
  try {
    const res = await apiRequest("get", `/communication/list`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const messageDelete = async (params) => {
  try {
    const res = await apiRequest("delete", `/communication/delete-all`, {
      body: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const messageDeleteSingle = async (params) => {
  try {
    const res = await apiRequest("patch", `/communication/message-delete`, {
      body: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const messageStatusChange = async (params) => {
  try {
    const res = await apiRequest("patch", `/communication/status`, {
      body: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const messageDetails = async (params) => {
  try {
    const res = await apiRequest("get", `/communication/details`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};
